




import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
@Component
export default class ComponentProductDescription extends Vue {
  @Prop({ type: String, default: null }) private html!: string

  private mounted(): void {
    this.$emit('loaded')
  }

  private $style!: IStyle

  private get classDescription() {
    return {
      [this.$style.description]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }
}
